import React, {useEffect, useState} from "react";
import './SetUp.css'
import Header from "../../../components/header/Header";
import Indicator from "../../common/components/Indicator";
import {Button, Form, message} from "antd";
import ModalContent from "../../../constant/ModalContent";
import {useNavigate} from "react-router-dom";
import {getAllPlans} from "../services/FamilyPlan.service";


export default function SetUp() {


    const [isLoading, setIsLoading] = useState(false);
    const searchParams = new URLSearchParams(window.location.search);
    const carrierPostData = window.location.search.match(/(?<=\?|&)carrierPostData=([^&]*)/)?.[1] ?? null;
    const sessionId = searchParams.get("sessionId") ?? null;
    const status = searchParams.get("status") ?? null;
    const mobileNumber = searchParams.get("msisdn") ?? null;
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [selectedPackageIndex, setSelectedPackageIndex] = useState(null);
    const storedJsonString = localStorage.getItem('selectedPackage');



    useEffect(() => {

        getAllPlanDetails()

    }, [])

    useEffect(()=>{

        if (data && storedJsonString){
            const storedObject = JSON.parse(storedJsonString);

            const itemIndex = data.findIndex(item => item.id === storedObject.id)

            if (itemIndex !== -1) {
                setSelectedPackageIndex(itemIndex)
            } else {
                console.log("Object not found in the array");
            }
        }

    },[storedJsonString,data])


    useEffect(() => {

        localStorage.setItem("carrierPostData", carrierPostData);
        localStorage.setItem("sessionId", sessionId);
        localStorage.setItem("status", status);
        localStorage.setItem("msisdn", mobileNumber)

        if (!carrierPostData || !sessionId || !status || !mobileNumber) {
            // Redirect to NotFoundPage if any data is null
            navigate('/not-found-page');
        }

    }, []);


    const getAllPlanDetails = async () => {
        setIsLoading(true);
        try {

            const response = await getAllPlans();
            setData(response)
            setIsLoading(false);


        } catch (error) {
            setIsLoading(false);
            message.error(ModalContent.GENERAL_ERROR_DESCRIPTION, 1);
            throw new Error(error);
        }

    };


    const handleSubmit = async (values) => {
        setIsLoading(true);

        try {
            if (data && (selectedPackageIndex !== null)) {

                const obj = data[selectedPackageIndex];

                localStorage.setItem("selectedPackage", JSON.stringify(obj))

                setIsLoading(false);

                navigate("/service-agreement");

            }

        } catch (error) {
            setIsLoading(false);
            message.error(ModalContent.GENERAL_ERROR_DESCRIPTION, 1);
            throw new Error(error);
        }
    }


    const assignIndex = async (index) => {
        setSelectedPackageIndex(index)
    }

    return (
        <div>
            <div style={{backgroundColor: "#E6E6E6", width: "100%"}}>
                <Header/>
            </div>

            {isLoading && <Indicator/>}


            {data &&
                (
                    <Form
                        className="form"
                        name="form"
                        onFinish={handleSubmit}
                    >
                        <h1 className="para-title">
                            Let's set up your standalone watch!
                        </h1>

                        <div className='para-sub-title'>
                            Family Setup allows you to use your iPhone to set up Apple Watch for a family member. With
                            Dialog One Number plan, you can set up this watch with it's own phone number for sending and
                            receiving calls
                            and messages, and use Siri, Maps, and more.
                        </div>

                        <div className='element-packages'>
                            {data.length > 0 &&
                                data.map((item, index) => (
                                    <div
                                        onClick={() => assignIndex(index)}
                                        key={index}
                                        style={{cursor: "pointer"}}
                                    >
                                        <div className={'element-card'} style={{
                                            border: `${selectedPackageIndex === index ? "2px solid #f13434" : ""}`
                                        }}>
                                            <div className={'element-card-name'}>
                                                {item.name}
                                            </div>
                                            <div className={'element-card-data'}>
                                                <span
                                                    className={'element-card-price'}>{item.pricingModel.amount} {item.pricingModel.uom} {item.pricingModel.billCycle}. </span>
                                                <span className={'element-card-description'}>{item.description}</span>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>


                        <div className='para-text'>
                            This Agreement constitutes the entire understanding between the Parties and supersedes all
                            prior agreements or understandings, whether oral or written.
                        </div>

                        <Form.Item>
                            <Button
                                className="mainButton agreeButton"
                                type="primary"
                                htmlType="submit"
                                shape={"round"}
                                style={{backgroundColor: "#f13434", marginRight: 10}}
                                disabled={selectedPackageIndex === null}
                            >
                                Continue
                            </Button>
                        </Form.Item>
                    </Form>
                )
            }

        </div>
    );
}